import { Component } from '@angular/core';
import { DBPanelInfo, FirebirdDBInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../basedatasource.panel';

@Component({
    selector: 'firebird-panel',
    templateUrl: './firebird.panel.html'
})
export class FirebirdPanel extends BaseDataSourcePanel {
    constructor() {
        super();
        this.DBInfoType = FirebirdDBInfo;
    }

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: FirebirdPanel,
            DBInfoType: FirebirdDBInfo
        };
    }
}
